import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { OrdersPropertiesValues } from "./OrdersPropertiesValues";
import { ServicesPropertiesValues } from "./ServicesPropertiesValues";
import { UsersPropertiesValues } from "./UsersPropertiesValues";

export class SelectCollection {
  ordersInstance: ListOfPropertiesValues = new OrdersPropertiesValues();
  usersInstance: ListOfPropertiesValues = new UsersPropertiesValues();
  servicesInstance: ListOfPropertiesValues = new ServicesPropertiesValues();

  get medicalOrders() {
    return this.ordersInstance;
  }

  get users() {
    return this.usersInstance;
  }

  get services() {
    return this.servicesInstance;
  }
}
